import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useFormSubmit } from "./useFormSubmit";

import { clearForm } from "../slices/formSlice";
import { sendForm } from "../slices/sendFormSlice";


export const useFeedbackForm = () => {
    const dispatch = useDispatch();
    const formId = "feedbackForm"
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);

    const fields = [
        {label: "Причина обращения", name: "title", validationRules: {required: true}},
        {label: "Описание проблемы", name: "feedback", validationRules: {required: true}}
    ]

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const body = {
                title: formValues.title,
                feedback: formValues.feedback
            }

            console.log("Отправляемые данные:", body);
            const action = await dispatch(sendForm({body, url: '/send-feedback', token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error;
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        error
    });

    console.log("useFeedbackForm вызван!");
    return {formId, loadingStatus, handleSend: handleSubmit}
}